export const difficulties = {
    easy: { rows: 8, cols: 8, mines: 10 },
    medium: { rows: 16, cols: 16, mines: 40 },
    hard: { rows: 16, cols: 30, mines: 99 },
  };

const directions = [
  [-1, -1], [-1, 0], [-1, 1],
  [0, -1], [0, 1],
  [1, -1], [1, 0], [1, 1]
];

export const generateBoard = (difficulty) => {
    const { rows, cols, mines } = difficulties[difficulty];
    const board = Array(rows).fill().map(() => Array(cols).fill(0));

    const placeMine = (row, col) => {
        board[row][col] = -1;
        directions.forEach(([dx, dy]) => {
            const newRow = row + dx;
            const newCol = col + dy;
            if (newRow >= 0 && newRow < rows && newCol >= 0 && newCol < cols && board[newRow][newCol] !== -1) {
                board[newRow][newCol]++;
            }
        });
    };

    const isValidPlacement = (row, col) => {
        if (board[row][col] === -1) return false;
        if (difficulty === 'easy') {
            return directions.every(([dx, dy]) => {
                const newRow = row + dx;
                const newCol = col + dy;
                return newRow < 0 || newRow >= rows || newCol < 0 || newCol >= cols || board[newRow][newCol] < 3;
            });
        }
        return true;
    };

    let minesPlaced = 0;
    while (minesPlaced < mines) {
        const row = Math.floor(Math.random() * rows);
        const col = Math.floor(Math.random() * cols);
        if (isValidPlacement(row, col)) {
            placeMine(row, col);
            minesPlaced++;
        }
    }

    return board;
};